/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';

/**
 * 
 * @export
 * @interface LeaderboardPrizeTier
 */
export interface LeaderboardPrizeTier {
    /**
     * 
     * @type {number}
     * @memberof LeaderboardPrizeTier
     */
    rankStart?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardPrizeTier
     */
    rankEnd?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof LeaderboardPrizeTier
     */
    rewardConfigIds?: Array<string>;
    /**
     * Catalog-item grants (reward-catalog Option B) — additive alongside rewardConfigIds during the migration.
     * @type {Array<RewardGrant>}
     * @memberof LeaderboardPrizeTier
     */
    rewardGrants?: Array<RewardGrant>;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardPrizeTier
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardPrizeTier
     */
    displayValue?: string;
}

/**
 * Check if a given object implements the LeaderboardPrizeTier interface.
 */
export function instanceOfLeaderboardPrizeTier(value: object): value is LeaderboardPrizeTier {
    return true;
}

export function LeaderboardPrizeTierFromJSON(json: any): LeaderboardPrizeTier {
    return LeaderboardPrizeTierFromJSONTyped(json, false);
}

export function LeaderboardPrizeTierFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardPrizeTier {
    if (json == null) {
        return json;
    }
    return {
        
        'rankStart': json['rankStart'] == null ? undefined : json['rankStart'],
        'rankEnd': json['rankEnd'] == null ? undefined : json['rankEnd'],
        'rewardConfigIds': json['rewardConfigIds'] == null ? undefined : json['rewardConfigIds'],
        'rewardGrants': json['rewardGrants'] == null ? undefined : ((json['rewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
        'description': json['description'] == null ? undefined : json['description'],
        'displayValue': json['displayValue'] == null ? undefined : json['displayValue'],
    };
}

export function LeaderboardPrizeTierToJSON(json: any): LeaderboardPrizeTier {
    return LeaderboardPrizeTierToJSONTyped(json, false);
}

export function LeaderboardPrizeTierToJSONTyped(value?: LeaderboardPrizeTier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rankStart': value['rankStart'],
        'rankEnd': value['rankEnd'],
        'rewardConfigIds': value['rewardConfigIds'],
        'rewardGrants': value['rewardGrants'] == null ? undefined : ((value['rewardGrants'] as Array<any>).map(RewardGrantToJSON)),
        'description': value['description'],
        'displayValue': value['displayValue'],
    };
}

